/* eslint-disable @typescript-eslint/no-useless-constructor */
import { StoreConfig, EntityStore, EntityState } from '@datorama/akita';
import { Injectable } from '@angular/core';
import { IRangeOfDevelopmentDetails } from 'typings/doenkids/doenkids';

export interface IRangeOfDevelopmentState extends EntityState<IRangeOfDevelopmentDetails> {}

@Injectable({ providedIn: 'root' })
@StoreConfig({ name: 'range-of-development' })
export class RangeOfDevelopmentStore extends EntityStore<IRangeOfDevelopmentState, IRangeOfDevelopmentDetails> {
  constructor() {
    super();
  }
}
